import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { processRbiItemsRefund } from '../../../../../actions/tools/RBIActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTSendMacroAndRefundItemsRBINode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRbiItemsRefund());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to refund the items and copy the response to the text box'}
      customErrorMessage={'Error refunding the items. Please try again later.'}
    />
  );
};

export default withConfirmation(DTSendMacroAndRefundItemsRBINode);
